import React, { useMemo } from "react";

import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Tooltip,
  Legend,
} from "chart.js";

import { Line } from "react-chartjs-2";

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Tooltip,
  Legend,
);

export default function ScorePlusDailyTrend({ records = [] }) {
  const chartData = useMemo(() => {
    const days = {};

    records.forEach((record) => {
      if (!days[record.date]) {
        days[record.date] = {
          total: 0,
          count: 0,
        };
      }

      days[record.date].total += Number(record.score) || 0;
      days[record.date].count++;
    });

    const labels = Object.keys(days).sort();

    const values = labels.map((date) =>
      Number((days[date].total / days[date].count).toFixed(2)),
    );

    return {
      labels,

      datasets: [
        {
          label: "Average Score",

          data: values,

          borderColor: "#22d3ee",

          backgroundColor: "rgba(34,211,238,.25)",

          fill: true,

          tension: 0.35,

          pointRadius: 4,

          pointHoverRadius: 7,
        },
      ],
    };
  }, [records]);

  const options = {
    responsive: true,

    maintainAspectRatio: false,

    plugins: {
      legend: {
        labels: {
          color: "#ffffff",
        },
      },
    },

    scales: {
      x: {
        ticks: {
          color: "#cbd5e1",
        },

        grid: {
          color: "#374151",
        },
      },

      y: {
        min: 0,

        max: 10,

        ticks: {
          color: "#cbd5e1",
        },

        grid: {
          color: "#374151",
        },
      },
    },
  };

  return (
    <div className="bg-gray-900 border border-gray-700 rounded-xl p-5">
      <div className="text-lg font-semibold text-white mb-4">
        Daily Score Trend
      </div>

      <div className="h-80">
        <Line data={chartData} options={options} />
      </div>
    </div>
  );
}
